import React, { Component } from 'react'
import { Button, Input, message } from 'antd'
import styled from 'styled-components'
import getOfflineCodeAPI from '@/API/getOfflineCode'

import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

const Div = styled.div`
  min-height: 740px;
`
const Content = styled.div`
  padding: 62px 0 0 85px;
  .fixed-width {
    display: inline-block;
    width: 100px;
    text-align: right;
  }
`

const Title = styled.h2`
  margin: 0 0 30px 0;
  font-size: 18px;
  color: #333;
  font-weight: normal;
`
const Imei = styled.div`
  margin: 0 0 30px 0;
  .ant-input {
    width: 260px;
    height: 40px;
    margin: 0 10px 0 10px;
  }
  sup {
    color: red;
    margin-right: 5px;
  }
  button {
    height: 40px;
    line-height: 40px;
  }
`
const Message = styled.div``
const Show = styled.span`
  display: inline-block;
  background: rgb(243, 245, 247);
  height: 40px;
  line-height: 40px;
  width: 340px;
  padding-left: 20px;
  border-radius: 5px;
  margin-right: 20px;
  vertical-align: middle;
`
const Tips = styled.span`
  color: red;
`

class DeletePassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      IMEI: '',
      password: '',
      tips: '',
      loading: false
    }
  }

  handleChange(e) {
    this.setState({
      IMEI: e.target.value
    })
  }

  handleGetPassword = () => {
    if (!this.state.IMEI) return message.warning(this.props.t('Please enter IMEI'))
    this.setState({ loading: true })
    getOfflineCodeAPI
      .getOfflineCode({ imei: this.state.IMEI })
      .then(res => {
        if (!res.data) {
          this.setState({ password: 'No result' })
        } else {
          this.setState({ password: res.data })
        }
      })
      .finally(() => {
        this.setState({ loading: false })
      })
  }

  render() {
    const { IMEI, password, tips, loading } = this.state
    const { t } = this.props

    return (
      <Div>
        <Content>
          <Title>{t('Get Offline Code To Unlock Device')}</Title>
          <Imei>
            <span className="fixed-width">
              <sup>*</sup>
              {`${t('IMEI')}：`}
            </span>
            <Input value={IMEI} onChange={this.handleChange.bind(this)} />{' '}
            {(
              <Button type="primary" onClick={this.handleGetPassword} loading={loading}>
                {t('Get')}
              </Button>
            )}
          </Imei>
          <Message>
            <span className="fixed-width">{`${t('Offline Code')}：`}</span>
            <Show>{password}</Show>
            <Tips>{tips}</Tips>
          </Message>
        </Content>
      </Div>
    )
  }
}

const mapStateToProps = state => {
  return {
    menus: state.menus,
    roleId: state.roleId,
  }
}

export default connect(mapStateToProps)(withTranslation()(DeletePassword))
